import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/lib/AuthContext';
import { isAdminUser } from '@/lib/adminAccess';

export function useRequireAdminRedirect() {
  const navigate = useNavigate();
  const { user, isAuthenticated, isLoadingAuth } = useAuth();
  const isAdmin = isAdminUser(user);

  useEffect(() => {
    if (isLoadingAuth) return;
    if (!isAuthenticated) {
      navigate('/Login', { replace: true });
    } else if (!isAdmin) {
      navigate('/Home', { replace: true });
    }
  }, [isAuthenticated, isAdmin, isLoadingAuth, navigate]);

  return {
    isAdmin,
    isLoadingAuth,
    canRenderProtectedContent: !isLoadingAuth && isAuthenticated && isAdmin,
  };
}
